import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import { locale } from 'primereact/api';

import './locale';

import translationPtBr from './locales/pt-BR.json';
import translationEnUs from './locales/en-US.json';
import translationEsCl from './locales/es-CL.json';

const resources = {
    'pt-BR': {
        translation: translationPtBr
    },
    'en-US': {
        translation: translationEnUs
    },
    'es-CL': {
        translation: translationEsCl
    }
};

const supportedLanguages = ['pt-BR', 'en-US', 'es-CL'];

const normalizeLanguage = (language) => {
    if (!language) return null;

    if (supportedLanguages.indexOf(language) >= 0) return language;

    const languagePrefix = language.split('-')[0];
    const languageMap = {
        pt: 'pt-BR',
        en: 'en-US',
        es: 'es-CL'
    };

    return languageMap[languagePrefix] || null;
};

const getUserLanguage = () => {
    if (typeof sessionStorage === 'undefined') return null;

    try {
        const auth = JSON.parse(sessionStorage.getItem('auth'));

        return normalizeLanguage(auth && (auth.idioma || auth.Idioma));
    } catch (error) {
        return null;
    }
};

const hasAuthenticatedUser = () => {
    if (typeof sessionStorage === 'undefined') return false;

    return !!sessionStorage.getItem('auth');
};

const getStoredLanguage = () => {
    if (typeof localStorage === 'undefined') return null;

    return normalizeLanguage(localStorage.getItem('appLang'));
};

const setStoredLanguage = (language) => {
    if (typeof localStorage === 'undefined' || !language) return;

    localStorage.setItem('appLang', language);
};

const getBrowserLanguage = () => {
    if (typeof navigator === 'undefined') return null;

    const languages = navigator.languages && navigator.languages.length
        ? navigator.languages
        : [navigator.language || navigator.userLanguage];

    for (let index = 0; index < languages.length; index++) {
        const normalizedLanguage = normalizeLanguage(languages[index]);

        if (normalizedLanguage) return normalizedLanguage;
    }

    return null;
};

const getInitialLanguage = () => {
    const userLanguage = getUserLanguage();
    const storedLanguage = getStoredLanguage();
    const authenticatedUser = hasAuthenticatedUser();

    if (userLanguage) return userLanguage;
    if (authenticatedUser) return 'pt-BR';
    if (storedLanguage) return storedLanguage;

    const browserLanguage = getBrowserLanguage() || 'pt-BR';
    setStoredLanguage(browserLanguage);

    return browserLanguage;
};

const initialLanguage = getInitialLanguage();

i18n
    .use(reactI18nextModule)
    .init({
        resources,
        lng: initialLanguage,
        fallbackLng: 'pt-BR',
        defaultNS: 'translation',
        interpolation: {
            escapeValue: false
        },
        react: {
            wait: false,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default'
        }
    });

locale(i18n.language);
i18n.on('languageChanged', (lang) => locale(lang));

export default i18n;
